export const API_ORIGIN = import.meta.env.VITE_IGNITION_API_ORIGIN ?? (
  import.meta.env.DEV ? "http://127.0.0.1:8000" : "https://ignition-api.openfusionlab.com"
);

export const APP_VERSION = "1.0.0";
